import {Error} from "../types/style";
import React from "react";

export const DefaultError = (props: {id: string; error?: string}) => {
  const {id, error} = props;
  return !error ? null : <Error id={`${id}-error`}>{props.error}</Error>;
};
